'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addSectionContainerClasses = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Ponyfill for Object.entries
var entries = function entries(obj) {
  var ownProps = Object.keys(obj);
  var i = ownProps.length;
  var resArray = new Array(i); // preallocate the Array

  while (i--) {
    resArray[i] = [ownProps[i], obj[ownProps[i]]];
  }

  return resArray;
};

// eslint-disable-next-line no-unused-vars
var events = ['shopify:section:load', 'shopify:section:select', 'shopify:section:deselect', 'shopify:section:unload', 'shopify:section:reorder', 'shopify:block:select', 'shopify:block:deselect'];

var addSectionContainerClasses = exports.addSectionContainerClasses = function addSectionContainerClasses() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      sectionId = _ref.sectionId;

  if (sectionId) {
    $('#shopify-section-' + sectionId).addClass(window.prg.sections[sectionId].classes.join(' '));
  } else {
    entries(window.prg.sections).forEach(function (_ref2) {
      var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
          id = _ref3[0],
          classes = _ref3[1].classes;

      return $('#shopify-section-' + id).addClass(classes.join(' '));
    });
  }
};

// const logEvent = event => {
//   console.log(event.type, event.detail);
// };

var handleShopifySectionLoad = function handleShopifySectionLoad() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$detail = _ref4.detail,
      detail = _ref4$detail === undefined ? {} : _ref4$detail;

  addSectionContainerClasses({ detail: detail });
};

// eslint-disable-next-line no-unused-vars
var handleShopifySectionSelect = function handleShopifySectionSelect() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref5$detail = _ref5.detail;

  _ref5$detail = _ref5$detail === undefined ? {} : _ref5$detail;
  var load = _ref5$detail.load,
      sectionId = _ref5$detail.sectionId;

  switch (sectionId) {
    case 'navigation-drawer':
      PubSub.publish(_Constants2.default.openNavigationDrawer, {});
      break;
  }
};

var handleShopifySectionDeselect = function handleShopifySectionDeselect() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref6$detail = _ref6.detail;

  _ref6$detail = _ref6$detail === undefined ? {} : _ref6$detail;
  var sectionId = _ref6$detail.sectionId;

  switch (sectionId) {
    case 'navigation-drawer':
      PubSub.publish(_Constants2.default.closeNavigationDrawer, {});
      break;
  }
};

var bindShopifySectionEvents = function bindShopifySectionEvents() {
  // shopify:section:unload => { sectionId }
  // shopify:section:reorder => { sectionId }
  // shopify:block:select => { blockId, sectionId, load }
  // shopify:block:deselect => { blockId, sectionId }
  // events.forEach(event => document.addEventListener(event, logEvent));
  document.addEventListener('shopify:section:load', handleShopifySectionLoad);
  document.addEventListener('shopify:section:select', handleShopifySectionSelect);
  document.addEventListener('shopify:section:deselect', handleShopifySectionDeselect);
};

exports.default = {
  bind: bindShopifySectionEvents
};